<template>
    <div class="aba-mapas" :class="{ disabled: isSaving }">
        <div class="map-route">
            <!-- MAPA -->
            <div class="maps">
                <GoogleMaps
                    ref="gmapComponent"
                    :center="mapcenter"
                    :dias="dias"
                    :day="mapDay"
                    :markers="lpsList"
                />
            </div>
            <div class="map-captions">
                <div class="caption-items">
                    <svg class="svg-icons green-marker">
                        <use
                            :xlink:href="require('@/assets/img/icons/map-marker.svg') + '#layer'"
                        ></use>
                    </svg>
                    <p>
                        {{ $t('marcador-endereco-promotor') }}
                    </p>
                </div>
                <div class="caption-items">
                    <svg class="svg-icons purple-marker">
                        <use
                            :xlink:href="require('@/assets/img/icons/map-marker.svg') + '#layer'"
                        ></use>
                    </svg>
                    <p>{{ $t('marcador-lps') }}</p>
                </div>
                <div class="caption-items">
                    <svg class="svg-icons orange-marker">
                        <use
                            :xlink:href="require('@/assets/img/icons/map-marker.svg') + '#layer'"
                        ></use>
                    </svg>
                    <p>
                        {{ $t('marcador-lps-rota') }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GoogleMaps from '@/components/shared/maps/MapasGoogleMaps.vue';

export default {
    components: {
        GoogleMaps,
    },
    props: {
        isSaving: {
            type: Boolean,
            default: false,
        },
        dias: null,
        mapDay: null,
        mapcenter: null,
        lpsList: [],
    },
};
</script>

<style lang="scss" scoped>
.aba-mapas {
    width: 100%;
    padding: 10px;
    background-color: $sovis-white;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    height: 100%;

    &.disabled {
        pointer-events: none;
    }
    .map-route {
        display: flex;
        flex-direction: column;
        height: 100%;
        .maps {
            flex-grow: 1;
        }
    }

    .map-captions {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        flex-direction: row;
        flex-wrap: nowrap;
        background: $sovis-white;
        padding: 10px;

        .caption-items {
            display: flex;
            justify-content: space-between;
            margin-right: 40px;

            .svg-icons {
                width: 20px;
                height: 26px;
                margin-right: 5px;
            }

            p {
                margin-bottom: 0;
                margin-top: 3px;
                font-size: 14px;
            }

            .green-marker {
                fill: #63c01a;
            }
            .purple-marker {
                fill: #7c37c2;
            }
            .orange-marker {
                fill: #ff9800;
            }
        }
    }
}
</style>
